import React from "react";
import {useCore} from "../hooks";
import './OrderDraftColumn.css'
import {Btn} from "./Btn.tsx";
import {ModalCustomOrderItem, ModalNotes, ModalSale, ModalVoucherCreate} from "./";

export const OrderDraftEditBtns: React.FC = () => {
  const { currentOrder, setCurrentOrder } = useCore()

  return (
    <div>
      <div className="w-full h-row flex items-center">
        <div className="w-full flex flex-row justify-between items-center">
          <div className="font-bold text-sm">Přidat:</div>
          <ModalCustomOrderItem />
          <ModalNotes />
          <ModalSale />
          <ModalVoucherCreate />
        </div>
      </div>
      {currentOrder?.note?.length > 0 && (
        <div>Poznámka: {currentOrder.note}</div>
      )}
      {currentOrder?.privateNote?.length > 0 && (
        <div>Interní poznámka: {currentOrder.privateNote}</div>
      )}
    </div>
  )
}
